import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../../../../../features/components/Form/MultiSelectBox'

import {
  clearGetAdditionalInterestCategories,
  getAdditionalInterestCategories
} from '../../../../../../../../../../modules/actions/tikTokConstants'
import { selectedTikTokAdAccountSelector } from '../../../../../../../../../../modules/selectors/adAccounts'
import {
  getAdditionalInterestCategoriesIsLoadingSelector,
  getAdditionalInterestCategoriesSelector
} from '../../../../../../../../../../modules/selectors/tikTokConstants'

export const INTEREST_KEYWORD_IDS = 'interest_keyword_ids'

const AdditionalInterestCategoriesMultiselect = ({ formik, disabled = false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { id: selectedAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const additionalInterestCategories = useSelector(getAdditionalInterestCategoriesSelector)
  const getAdditionalInterestCategoriesIsLoading = useSelector(getAdditionalInterestCategoriesIsLoadingSelector)

  const [searchValue, setSearchValue] = useState('')

  const additionalInterestOptions = useMemo(() => {
    return (
      additionalInterestCategories?.additional_interest?.search_result?.[searchValue]?.map(item => ({
        ...item,
        value: item.id,
        label: item.name
      })) || []
    )
  }, [additionalInterestCategories, searchValue])

  const { values, setFieldValue } = formik

  const fetchCategoriesAndHashtags = useCallback(
    searchValue => {
      if (searchValue) {
        setSearchValue(searchValue)
        dispatch(
          getAdditionalInterestCategories({
            account: selectedAdAccountId,
            search_keywords: [searchValue],
            sub_targeting_types: ['ADDITIONAL_INTEREST']
          })
        )
      }
    },
    [dispatch, selectedAdAccountId]
  )

  useEffect(() => {
    return () => {
      dispatch(clearGetAdditionalInterestCategories())
      setSearchValue('')
    }
  }, [dispatch, selectedAdAccountId])

  return (
    <div>
      <MultiSelectBox
        onSearch={fetchCategoriesAndHashtags}
        placeholder={t('Additional Interest Categories')}
        options={additionalInterestOptions}
        name={INTEREST_KEYWORD_IDS}
        value={values[INTEREST_KEYWORD_IDS]}
        isLoading={getAdditionalInterestCategoriesIsLoading}
        setFieldValue={setFieldValue}
        isDisabled={disabled}
      />
    </div>
  )
}

export default AdditionalInterestCategoriesMultiselect
